import React, { FC } from 'react';
import { useAuthUser } from '@yakoffice/yakoffice-firebase';
import { SessionRegions } from '../../../components/session-regions';
import { useParams } from 'react-router-dom';
import { NoAccess } from '@yakoffice/shared-components';
import { ProjectTheme } from '@yakoffice/project-theme';

export const SessionsIndex: FC = () => {

    const { projectId } = useParams() as { projectId: string };
    const authUser = useAuthUser();

    return <ProjectTheme>
        {authUser?.isAuthorisedForHostedToolProject(projectId)

            ? <SessionRegions />
            : <NoAccess />
        }
    </ProjectTheme>;
};
